module.exports = __webpack_public_path__ + "static/img/qr-code.f903a2d8.jpg";